import { render, staticRenderFns } from "./zcfg.vue?vue&type=template&id=6ea73461&scoped=true&"
import script from "./zcfg.vue?vue&type=script&lang=js&"
export * from "./zcfg.vue?vue&type=script&lang=js&"
import style0 from "./zcfg.vue?vue&type=style&index=0&id=6ea73461&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ea73461",
  null
  
)

export default component.exports